import { Col, FormGroup, Label, Row } from "reactstrap";
import CommonFileUpload from "../../../../../Utils/CommonComponents/CommonFileUpload";
import { UploadProjectFile } from "../../../../../Utils/Constants";

export default function UploadFile() {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label>{UploadProjectFile}</Label>
          <FormGroup className="dropzone bg-light-primary dz-clickable custom-dropzone">
            <CommonFileUpload />
          </FormGroup>
        </FormGroup>
      </Col>
    </Row>
  );
}
